import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';

import { MaskInput } from '@sravni/react-design-system';
import { usePrevious } from '@sravni/react-utils';

import { IPromoBlockProps } from '../Blocks/BigBlock';

const rightLetters = Array.from('АВЕКМНОРСТУХавекмннорстухABEKMHOPCTYXabekmnhopctyx');
const digit = /\d/;
const letter = new RegExp(`[${rightLetters.join('')}]`);
const space = ' ';
const MASK_REGISTRATION_NUMBER = [
  letter,
  space,
  digit,
  digit,
  digit,
  space,
  letter,
  letter,
  space,
  space,
  digit,
  digit,
  digit,
];

// const defaultValue = 'A 000 AA 000';

export const OsagoForm = memo<IPromoBlockProps>(({ setValue: setValueAtParentBlock, handleEnterEvent }) => {
  const [value, setValue] = useState('');

  const valueForUrl = useMemo(() => `${value}`.replace(/[\s_]/g, ''), [value]);
  const prevValueForUrl = usePrevious(valueForUrl);

  const handleChange = useCallback((event: React.FormEvent<HTMLInputElement>) => {
    const userValue = event.currentTarget.value;

    const normalizedValue = [...userValue]
      .map((char) => {
        if (!rightLetters.includes(char)) {
          return char;
        }
        const charIndex = rightLetters.indexOf(char);
        if (charIndex < rightLetters.length / 2) {
          return char;
        }

        const indexOfKirillChar = charIndex - rightLetters.length / 2;
        return rightLetters[indexOfKirillChar].toUpperCase();
      })
      .join('');

    setValue(normalizedValue.replace(/\s/g, ''));
  }, []);

  const handleSubmit = useCallback(
    (event) => {
      handleEnterEvent(event);
    },
    [handleEnterEvent],
  );

  useEffect(() => {
    if (prevValueForUrl === valueForUrl) return;

    setValueAtParentBlock(valueForUrl);
  }, [prevValueForUrl, setValueAtParentBlock, valueForUrl]);

  return (
    <MaskInput
      mask={MASK_REGISTRATION_NUMBER}
      label={'Номер авто'}
      value={value}
      onChange={handleChange}
      onKeyUp={(e) => handleSubmit(e)}
    />
  );
});
